// extracted by mini-css-extract-plugin
export default {"noDataMsg":"CVChart_noDataMsg__DHVUx","tooltipClass":"CVChart_tooltipClass__hJqSX"};